import React from "react";
import { cn } from "../../lib/cn";

/** Soft category label for service detail pages (light surfaces). */
export function ServiceTag({ children, className }) {
  return (
    <div
      className={cn(
        "mb-4 inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700",
        className
      )}
    >
      <span className="h-1 w-1 shrink-0 rounded-full bg-teal-600" aria-hidden />
      {children}
    </div>
  );
}
